import {useEffect, useState, useContext } from 'react';
import { useApolloClient, useQuery } from '@apollo/react-hooks';
import ls from 'local-storage';
import { useLocation } from 'react-use';

import { getUrl, APPS } from '@squirrellearningltd/go-shared-utils';

import { FORCED_LOGOUT } from '../services/graphql';

import { APP_NAME } from '../../../services/constants';
import { AuthContext } from '../../../services/user/AuthProvider';

const RouteCapture = () => {

    const [targetRoute, setTargetRoute] = useState('');
    const client = useApolloClient();
    const { data } = useQuery(FORCED_LOGOUT);
    const { setCurrentUser } = useContext(AuthContext);

    const locationState = useLocation();

    const forceLogout = () => {
        ls.clear();
        client.clearStore();
        setCurrentUser(null);
        window.location.href = `${getUrl(APPS.go_portal_pupil)}/redirectAfterLogin/${APP_NAME}?targetUrl=${targetRoute}`;
    }

    useEffect(() => {
        setTargetRoute(locationState.pathname);
    }, [setTargetRoute, locationState]);

    useEffect(() => {
        if (ls('go_pupil_user') && ls('go_pupil_user') === 'undefined') {
            forceLogout();
        }
    });

    if (data && data.forcedLogout) {
        forceLogout();
    }

    return null;
}

export default RouteCapture;
